import { createContext, useContext, useState } from "react";
import useApiRequest from "../api/api";
import apiRoutes from "../api/routes";
import { useSearchParams } from "react-router-dom";

const BetsContext = createContext();

export const useBets = () => {
  const context = useContext(BetsContext);
  if (!context) {
    throw new Error("useBets must be used within a BetsProvider");
  }
  return context;
};

export const BetsProvider = ({ children }) => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const [bets, setBets] = useState([]);
  const { makeApiCall } = useApiRequest();

  const fetchBets = async (showLoader = true) => {
    try {
      const response = await makeApiCall(apiRoutes.bets.getBets(id), "GET");
      if (response?.data) {
        const mappedBets = response.data.map((bet) => ({
          bettor: bet.betUsername,
          bettorImage: bet.bettorImage,
          racerImage: bet.racerImage,
          racer: bet.betRacer,
          totalBet: bet.betAmount,
          estPayout: bet.estimatePayout,
        }));
        setBets(mappedBets);
      }
    } catch (error) {
      console.error("Failed to fetch bets:", error);
    }
  };

  return (
    <BetsContext.Provider value={{ fetchBets, bets }}>
      {children}
    </BetsContext.Provider>
  );
};
